<form nz-form [formGroup]="form" theme>
  <div class="row">
    <nz-alert
      class="mb-4"
      nzType="warning"
      nzMessage="Para agilizar seu cadastro, buscaremos dados complementares no site da Receita Federal.
  Este é um procedimento seguro e o sigilo dos seus dados é garantido pela nossa plataforma"
    ></nz-alert>
  </div>
  <app-pet-data-form [form]="form"></app-pet-data-form>
  <app-personal-data-form
    [form]="formResponsible"
    [isResponsible]="true"
    [showAlertMsg]="false"
  ></app-personal-data-form>
  <app-contacts-data-form [form]="formResponsible" [showAlertMsg]="false"></app-contacts-data-form>
  <app-address-data-form
    [form]="formResponsible.get('address')"
    [showAlertMsg]="false"
  ></app-address-data-form>
</form>
